import React from 'react'
import { Col, FormGroup, Input, Label, Row } from 'reactstrap'
import InternationalPhoneInput from '../../../common/InternationalPhoneInput'
import CoverageZonesInput from '../CoverageZonesInput'
import FieldError from '../FieldError'

const Required = () => <span className="text-danger ml-1">*</span>

const ContactCoverageStep = ({ form, errors, onChange }) => (
  <>
    <h6 className="text-uppercase text-600 fs--1 mb-3">Contacto</h6>
    <Row form>
      <Col md={6}>
        <FormGroup>
          <Label for="email">
            Correo electrónico
            <Required />
          </Label>
          <Input
            id="email"
            type="email"
            autoComplete="email"
            value={form.email}
            invalid={Boolean(errors.email)}
            onChange={({ target }) => onChange('email', target.value)}
          />
          <small className="text-600 d-block mt-1">Con este correo iniciarás sesión.</small>
          <FieldError error={errors.email} />
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label for="phone">
            Teléfono móvil
            <Required />
          </Label>
          <InternationalPhoneInput
            id="phone"
            autoComplete="tel"
            placeholder="Número de teléfono"
            invalid={Boolean(errors.phone)}
            value={form.phone || undefined}
            onChange={(value) => onChange('phone', value || '')}
          />
          <small className="text-600 d-block mt-1">Preferiblemente con WhatsApp.</small>
          <FieldError error={errors.phone} />
        </FormGroup>
      </Col>
    </Row>

    <h6 className="text-uppercase text-600 fs--1 mb-3 mt-2">Cobertura</h6>
    <FormGroup>
      <Label>
        Zonas o sectores donde trabajas
        <Required />
      </Label>
      <CoverageZonesInput
        value={form.coverage_zones}
        invalid={Boolean(errors.coverage_zones)}
        onChange={(zones) => onChange('coverage_zones', zones)}
      />
      <small className="text-600 d-block mt-1">Escribe cada zona y presiona Enter. Puedes agregar hasta 20.</small>
      <FieldError error={errors.coverage_zones} />
    </FormGroup>

    <h6 className="text-uppercase text-600 fs--1 mb-3 mt-4">Contraseña</h6>
    <Row form>
      <Col md={6}>
        <FormGroup>
          <Label for="password">
            Contraseña
            <Required />
          </Label>
          <Input
            id="password"
            type="password"
            autoComplete="new-password"
            value={form.password}
            invalid={Boolean(errors.password)}
            onChange={({ target }) => onChange('password', target.value)}
          />
          <small className="text-600 d-block mt-1">Mínimo 8 caracteres.</small>
          <FieldError error={errors.password} />
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label for="password_confirmation">
            Confirmar contraseña
            <Required />
          </Label>
          <Input
            id="password_confirmation"
            type="password"
            autoComplete="new-password"
            value={form.password_confirmation}
            invalid={Boolean(errors.password_confirmation)}
            onChange={({ target }) => onChange('password_confirmation', target.value)}
          />
          <FieldError error={errors.password_confirmation} />
        </FormGroup>
      </Col>
    </Row>
  </>
)

export default ContactCoverageStep
